import type { ReactNode } from 'react';

import { Card } from '@/components/ui/card';
import { Skeleton } from '@/ui/components/skeleton/skeleton';

interface StatsCardProps {
  'data-testid'?: string;
  title: string;
  value: number;
  description: string;
  color: string;
  icon: ReactNode;
  isLoading?: boolean;
}

export function StatsCard({
  'data-testid': dataTestId,
  title,
  value,
  description,
  color,
  icon,
  isLoading = false,
}: StatsCardProps) {
  const textColor = value > 0 ? color : 'text-muted-foreground';
  return (
    <Card className="border-gray-200 p-6" data-testid={dataTestId}>
      <div className="flex flex-row items-center justify-between space-y-0 pb-2">
        <h3 className="text-sm font-medium">{title}</h3>
        <div className={textColor}>{icon}</div>
      </div>
      <div>
        {isLoading ? (
          <Skeleton className="mb-1 h-8 w-16" />
        ) : (
          <div
            className={`text-2xl font-bold ${textColor}`}
            data-testid="stats-card-value"
          >
            {value}
          </div>
        )}
        <p className="text-xs text-muted-foreground">{description}</p>
      </div>
    </Card>
  );
}
